export const controller = Symbol('controller')
